import { red100 } from "material-ui/styles/colors";
import React, { useEffect } from "react";
import { FormFeedback } from "reactstrap";
import { t } from "i18next";

const DropdownField = ({
  input,
  label,
  className,
  options,
  placeholder,
  required,
  readonly,
  disabled,
  onChange,
  onClick,
  val,
  meta: { touched, error },
  defaultOpen = false,
  size = 0,
  style = {},
}) => {
  let isError = touched && typeof error !== "undefined";
  let handleChange = (e) => {
    if (readonly) {
      return;
    }
    input.onChange(e);
  };

  let requiredSpan = required && <span className="required">*</span>;
  const selectClass =
    className + " form-control" + (isError ? " is-invalid" : "");
  // const disStatus = disabled ? "disabled" : "";
  const disStatus = !!disabled;
  var finalVal = input.value;

  // If amounNewValue (passed via `val`) is defined and differs, use it
  if (typeof val !== "undefined" && val !== input.value) {
    finalVal = val;
  }

  useEffect(() => {
    if (!!defaultOpen && input.name) {
      var mySelectElement = document.getElementById(input.name);
      mySelectElement.click();
    }
  }, [defaultOpen, input.name]);
  return (
    <div>
      {label && (
        <label>
          {label} {requiredSpan}
        </label>
      )}
      <div className="select_box">
        <select
          size={size}
          style={{
            height: "33.59px",
            border: 0,
            ...style,
          }}
          name={input.name}
          className={selectClass}
          value={finalVal}
          onChange={handleChange}
          onClick={onClick}
          readOnly={readonly}
          disabled={disStatus}
          id={input.name}
        >
          {placeholder && <option value="">{placeholder}</option>}
          {options &&
            options.map((option, i) => {
              if (typeof option.optGroup !== "undefined") {
                return <optgroup key={i} label={option.optGroup} />;
              }

              return (
                <option
                  key={i}
                  value={option.value}
                  style={{
                    padding: "10px",
                    marginBottom: "10px",
                    marginTop: "10px",
                    // wordBreak: "break-word",
                    display: "flex",
                    flexWrap: "wrap",
                    overflow: "scroll",
                  }}
                  // Special treatment for Nutrient and Unit dropdown because these has colon and if passed to translation the label will be altered. For example, "Hour:Minute (hh:mm)" will become "Minute (hh.mm)"  
                >
                  {input.name === "nutrients" || input.name === "unit" ? option.label : t(option.label)}
                </option>
              );
            })}
        </select>
      </div>
      {isError && <FormFeedback>{error}</FormFeedback>}
    </div>
  );
};

export default DropdownField;



// WEBPACK FOOTER //
// ./src/components/Dropdown.js